import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import AboutUs from "./pages/about-us";
import ContactUs from "./pages/contact-us";
import ProductDetails from "./pages/product-details";
import CartPage from "./pages/cart";
import CheckoutPage from "./pages/checkout";
import WishlistPage from "./pages/wishlist";
import MyAccount from "./pages/my-account";
import SuccessPage from "./pages/success-page";
import MyOrders from "./pages/my-orders";
import AddressBook from "./pages/address-book";
import OrderDetailsPage from "./pages/my-orders/orderDetailsPage";
import CollectionsPage from "./pages/collections";
import PrivacyPolicy from "./pages/privacy-policy";
import TermsAndConditions from "./pages/terms-and-conditions";
import Support from "./pages/support";
import CopyrightPage from "./pages/copyright";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/product-details/:slug" element={<ProductDetails />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/wishlist" element={<WishlistPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/success" element={<SuccessPage />} />
      <Route path="/my-orders" element={<MyOrders />} />
      <Route path="/my-orders/:slug" element={<OrderDetailsPage />} />
      <Route path="/my-account" element={<MyAccount />} />
      <Route path="/address-book" element={<AddressBook />} />
      <Route
        path="/collections/sub-category/:slug"
        element={<CollectionsPage />}
      />
      <Route path="/collections/category/:slug" element={<CollectionsPage />} />
      <Route path="/collections" element={<CollectionsPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/support" element={<Support />} />
      <Route path="/copyright" element={<CopyrightPage />} />
    </Routes>
  );
};

export default AppRoutes;
